module.exports = __webpack_public_path__ + "img/upload.28d5f915.png";